export enum RootCauseCategory {
    CATEGORY_1 = 1,
    CATEGORY_2 = 2,
    CATEGORY_3 = 3,
    CATEGORY_4 = 4,
    CATEGORY_5 = 5,
    CATEGORY_6 = 6,
    CATEGORY_8 = 8,
    CATEGORY_9 = 9,
    CATEGORY_21 = 21,
    CATEGORY_22 = 22,
    CATEGORY_23 = 23,
    CATEGORY_24 = 24,
    CATEGORY_25 = 25,
    CATEGORY_26 = 26,
    CATEGORY_31 = 31,
    CATEGORY_32 = 32,
    CATEGORY_33 = 33,
    CATEGORY_34 = 34,
    CATEGORY_40 = 40,
    CATEGORY_42 = 42,
    CATEGORY_43 = 43,
    CATEGORY_44 = 44,
    CATEGORY_51 = 51,
    CATEGORY_52 = 52,
    CATEGORY_53 = 53,
    CATEGORY_54 = 54,
    CATEGORY_55 = 55,
    CATEGORY_56 = 56,
    CATEGORY_57 = 57,
    CATEGORY_58 = 58,
    CATEGORY_59 = 59,
    CATEGORY_63 = 63,
    CATEGORY_64 = 64,
    CATEGORY_65 = 65,
    CATEGORY_66 = 66,
    CATEGORY_67 = 67,
    CATEGORY_68 = 68,
    CATEGORY_69 = 69,
    CATEGORY_70 = 70,
    CATEGORY_71 = 71,
    CATEGORY_72 = 72,
    CATEGORY_73 = 73,
    CATEGORY_74 = 74,
    CATEGORY_75 = 75,
    CATEGORY_76 = 76,
    CATEGORY_77 = 77,
    CATEGORY_78 = 78,   // Innate Immune Response for RBC Possible Root Causes (WBC = optimal + NLR ↑)
    CATEGORY_79 = 79,   // Adaptive Immune Response for RBC Possible Root Causes (WBC = optimal + NLR ↓)
    CATEGORY_80 = 80,
    CATEGORY_81 = 81,
    CATEGORY_82 = 82,
    CATEGORY_83 = 83,
    CATEGORY_84 = 84,
    CATEGORY_85 = 85,
    CATEGORY_86 = 86,
    CATEGORY_91 = 91,
    CATEGORY_92 = 92,
    CATEGORY_93 = 93,
    CATEGORY_94 = 94,
    CATEGORY_150 = 150, // This is a special category to obtain further considerations for Bone Marrow Overproduction
    CATEGORY_200 = 200,
    CATEGORY_201 = 201,
    CATEGORY_202 = 202,
    CATEGORY_203 = 203,
    CATEGORY_204 = 204,
    CATEGORY_205 = 205,
    CATEGORY_206 = 206,
    CATEGORY_207 = 207,
    CATEGORY_300 = 300,
    CATEGORY_301 = 301,
    CATEGORY_302 = 302,
    CATEGORY_303 = 303,
    CATEGORY_304 = 304,
    CATEGORY_305 = 305,
    CATEGORY_306 = 306,
    CATEGORY_307 = 307,
    CATEGORY_308 = 308,
    CATEGORY_309 = 309,
    CATEGORY_310 = 310,
    CATEGORY_311 = 311,
    CATEGORY_312 = 312,
    CATEGORY_313 = 313,
    CATEGORY_314 = 314,
    CATEGORY_400 = 400,
    CATEGORY_401 = 401,
    CATEGORY_402 = 402,
    CATEGORY_403 = 403,
    CATEGORY_404 = 404,
    CATEGORY_405 = 405,
    CATEGORY_406 = 406,
    CATEGORY_408 = 408,
    CATEGORY_409 = 409,
    CATEGORY_410 = 410,
    CATEGORY_411 = 411,
    CATEGORY_412 = 412,
    CATEGORY_413 = 413,
    CATEGORY_414 = 414,
    CATEGORY_415 = 415,
    CATEGORY_416 = 416,
    CATEGORY_417 = 417,
    CATEGORY_418 = 418,
    CATEGORY_419 = 419,
    CATEGORY_420 = 420,
    CATEGORY_421 = 421,
    CATEGORY_422 = 422,
    CATEGORY_423 = 423,
    CATEGORY_425 = 425,
    CATEGORY_500 = 500,
    CATEGORY_501 = 501,
    CATEGORY_502 = 502,
    CATEGORY_503 = 503,
    CATEGORY_507 = 507,
    CATEGORY_508 = 508,
    CATEGORY_509 = 509,
    CATEGORY_603 = 603,
    CATEGORY_604 = 604,
    CATEGORY_605 = 605,
    CATEGORY_606 = 606,
    CATEGORY_607 = 607,
    CATEGORY_608 = 608,
    CATEGORY_609 = 609,
    CATEGORY_700 = 700,
    CATEGORY_701 = 701,
    CATEGORY_702 = 702,
    CATEGORY_703 = 703,
    CATEGORY_800 = 800,
    CATEGORY_801 = 801,
    CATEGORY_802 = 802,
    CATEGORY_803 = 803,
    CATEGORY_804 = 804,
    CATEGORY_805 = 805,
    CATEGORY_806 = 806,
    CATEGORY_901 = 901,
    CATEGORY_902 = 902,
    CATEGORY_903 = 903,
    CATEGORY_904 = 904,
    CATEGORY_949 = 949,
    CATEGORY_950 = 950,
    CATEGORY_951 = 951,
    CATEGORY_952 = 952,
    CATEGORY_955 = 955,
    CATEGORY_960 = 960,
    CATEGORY_998 = 998,   // This is a special category for terms of use
    CATEGORY_999 = 999,   // This is a special category for a generic disclaimer section
    CATEGORY_1000 = 1000, // This is a special category for Dehydration,
    CATEGORY_1100 = 1100, // This is a special category for Acute Dehydration
    CATEGORY_1200 = 1200, // This is a special category for Chronic Dehydration
    CATEGORY_1300 = 1300, // This is a special category for Oxygen Insufficiency
    CATEGORY_1400 = 1400, // This is a special category for Oxygen Insufficiency related to cigarettes
    PDF = 1750, // This is a special category for exporting a PDF
    CATEGORY_1755 = 1755,
    CATEGORY_1760 = 1760,
    CATEGORY_1761 = 1761,
    CATEGORY_1762 = 1762,
    CATEGORY_1765 = 1765,
    CATEGORY_2000 = 2000, // These are for anemia probability
    CATEGORY_2010 = 2010,
    CATEGORY_2020 = 2020,
    CATEGORY_2030 = 2030,
    CATEGORY_2040 = 2040,
    CATEGORY_2050 = 2050,
    CATEGORY_2060 = 2060,
    CATEGORY_2070 = 2070,
    CATEGORY_2080 = 2080,
    CATEGORY_2090 = 2090,
    CATEGORY_2100 = 2100,
    CATEGORY_2110 = 2110,
    CATEGORY_2120 = 2120,
    CATEGORY_2130 = 2130,
    CATEGORY_2140 = 2140,
    CATEGORY_2150 = 2150,
    CATEGORY_2160 = 2160,
    CATEGORY_2170 = 2170,
    CATEGORY_2180 = 2180,
    CATEGORY_2190 = 2190,
    CATEGORY_2200 = 2200,
    CATEGORY_2210 = 2210,
    CATEGORY_2220 = 2220,
    CATEGORY_2230 = 2230,
    CATEGORY_2240 = 2240,
    CATEGORY_2250 = 2250,
    CATEGORY_2260 = 2260,
    CATEGORY_2270 = 2270,
    CATEGORY_2280 = 2280,
    CATEGORY_2290 = 2290,
    CATEGORY_2300 = 2300,
    CATEGORY_2310 = 2310,
    CATEGORY_2320 = 2320,
    CATEGORY_2330 = 2330,
    CATEGORY_2340 = 2340,
    CATEGORY_2350 = 2350,
    CATEGORY_2360 = 2360,
    CATEGORY_2370 = 2370,
    CATEGORY_2380 = 2380,
    CATEGORY_2390 = 2390,
    CATEGORY_2400 = 2400,
    CATEGORY_2410 = 2410,
    CATEGORY_2420 = 2420,
    CATEGORY_2430 = 2430,
    CATEGORY_2440 = 2440,
    CATEGORY_2450 = 2450,
    CATEGORY_2460 = 2460,
    CATEGORY_2470 = 2470,
    CATEGORY_3000 = 3000,
    CATEGORY_3010 = 3010,
    CATEGORY_3015 = 3015,
    CATEGORY_3020 = 3020,
    CATEGORY_3030 = 3030,
    CATEGORY_3040 = 3040,
    CATEGORY_3050 = 3050,
    CATEGORY_3060 = 3060,
    CATEGORY_3070 = 3070,
    CATEGORY_3080 = 3080,
    CATEGORY_3090 = 3090,
    CATEGORY_3100 = 3100,
    CATEGORY_3110 = 3110,
    CATEGORY_3120 = 3120,
    CATEGORY_3130 = 3130,
    CATEGORY_3140 = 3140,
    CATEGORY_3150 = 3150,
    CATEGORY_3160 = 3160,
    CATEGORY_3170 = 3170,
    CATEGORY_3172 = 3172,
    CATEGORY_3174 = 3174,
    CATEGORY_4000 = 4000,
    CATEGORY_4010 = 4010,
    CATEGORY_4020 = 4020,
    CATEGORY_4030 = 4030,
    CATEGORY_4040 = 4040,
    CATEGORY_4050 = 4050,
    CATEGORY_4060 = 4060,
    CATEGORY_4070 = 4070,
    CATEGORY_4080 = 4080,
    CATEGORY_4090 = 4090,
    CATEGORY_4100 = 4100,
    CATEGORY_4110 = 4110,
    CATEGORY_4120 = 4120,
    CATEGORY_4130 = 4130,
    CATEGORY_4140 = 4140,
    CATEGORY_4150 = 4150,
    CATEGORY_4160 = 4160,
    CATEGORY_4170 = 4170,
    CATEGORY_5000 = 5000,
    CATEGORY_5010 = 5010,
    CATEGORY_5020 = 5020,
    CATEGORY_5030 = 5030,
    CATEGORY_5040 = 5040,
    CATEGORY_5060 = 5060,
    CATEGORY_5070 = 5070,
    CATEGORY_6000 = 6000,
    CATEGORY_6010 = 6010,
    CATEGORY_6020 = 6020,
    CATEGORY_6030 = 6030,
    CATEGORY_6040 = 6040,
    CATEGORY_6050 = 6050,
    CATEGORY_6060 = 6060,
    CATEGORY_6070 = 6070,
    CATEGORY_6075 = 6075,
    CATEGORY_6076 = 6076,
    CATEGORY_6077 = 6077,
    CATEGORY_6080 = 6080,
    CATEGORY_6085 = 6085,
    CATEGORY_6090 = 6090,
    CATEGORY_6091 = 6091,
    CATEGORY_6092 = 6092,
    CATEGORY_6094 = 6094,
    CATEGORY_6096 = 6096,
    CATEGORY_6098 = 6098,
    CATEGORY_7000 = 7000,
    CATEGORY_7010 = 7010,
    CATEGORY_7020 = 7020,
    CATEGORY_7030 = 7030,
    CATEGORY_7050 = 7050,
    CATEGORY_7060 = 7060,
    CATEGORY_7070 = 7070,
    CATEGORY_7080 = 7080,
    CATEGORY_7090 = 7090,
    CATEGORY_8000 = 8000,
    CATEGORY_8010 = 8010,
    CATEGORY_8020 = 8020,
    CATEGORY_8030 = 8030,
    CATEGORY_8040 = 8040,
    CATEGORY_8050 = 8050,
    CATEGORY_8060 = 8060,
    CATEGORY_8070 = 8070,
    CATEGORY_8072 = 8072,
    CATEGORY_8074 = 8074,
    CATEGORY_8076 = 8076,
    CATEGORY_8078 = 8078,
    CATEGORY_8080 = 8080,
    CATEGORY_8090 = 8090,
    CATEGORY_8100 = 8100,
    CATEGORY_8110 = 8110,
    CATEGORY_8120 = 8120,
    CATEGORY_8130 = 8130,
    CATEGORY_8140 = 8140,
    CATEGORY_8150 = 8150,
    CATEGORY_8160 = 8160,
    CATEGORY_8170 = 8170,
    CATEGORY_8180 = 8180,
    CATEGORY_8190 = 8190,
    CATEGORY_8200 = 8200,
    CATEGORY_8210 = 8210,
    CATEGORY_8220 = 8220,
    CATEGORY_8230 = 8230,
    CATEGORY_8240 = 8240,
    CATEGORY_8250 = 8250,
    CATEGORY_8260 = 8260,
    CATEGORY_8270 = 8270,
    CATEGORY_8280 = 8280,
    CATEGORY_8290 = 8290,
    CATEGORY_8300 = 8300,
    CATEGORY_8310 = 8310,
    CATEGORY_9000 = 9000,
    CATEGORY_9010 = 9010,
    CATEGORY_9020 = 9020,
    CATEGORY_9030 = 9030,
    CATEGORY_9032 = 9032,
    CATEGORY_9034 = 9034,
    CATEGORY_9040 = 9040,
    CATEGORY_9050 = 9050,
    CATEGORY_9060 = 9060,
    CATEGORY_9070 = 9070,
    CATEGORY_9080 = 9080,
    CATEGORY_9090 = 9090,
    CATEGORY_9100 = 9100,
    CATEGORY_9110 = 9110,
    CATEGORY_9120 = 9120,
    CATEGORY_10000 = 10000,
    CATEGORY_10010 = 10010,
    CATEGORY_10020 = 10020,
    CATEGORY_10030 = 10030,
    CATEGORY_10040 = 10040,
    CATEGORY_10050 = 10050,
    CATEGORY_10060 = 10060,
    CATEGORY_10070 = 10070,
    CATEGORY_10080 = 10080,
    CATEGORY_10090 = 10090,
    CATEGORY_11010 = 11010, // These are are for immune system disorder probability
    CATEGORY_11050 = 11050,
    CATEGORY_11055 = 11055,
    CATEGORY_11057 = 11057,
    CATEGORY_11060 = 11060,
    CATEGORY_11063 = 11063,
    CATEGORY_11065 = 11065,
    CATEGORY_11068 = 11068,
    CATEGORY_11070 = 11070,
    CATEGORY_11075 = 11075,
    CATEGORY_11078 = 11078,
    CATEGORY_11080 = 11080,
    CATEGORY_11082 = 11082,
    CATEGORY_11084 = 11084,
    CATEGORY_11086 = 11086,
    CATEGORY_11088 = 11088,
    CATEGORY_11090 = 11090,
    CATEGORY_11091 = 11091,
    CATEGORY_11093 = 11093,
    CATEGORY_11095 = 11095,
    CATEGORY_11099 = 11099,
    CATEGORY_11200 = 11200,
    CATEGORY_11210 = 11210,
    CATEGORY_11220 = 11220,
    CATEGORY_11230 = 11230,
    CATEGORY_11240 = 11240,
    CATEGORY_11250 = 11250,
    CATEGORY_11260 = 11260,
    CATEGORY_11270 = 11270,
    CATEGORY_11280 = 11280,
    CATEGORY_11290 = 11290,
    CATEGORY_11300 = 11300,
    CATEGORY_11310 = 11310,
    CATEGORY_11320 = 11320,
    CATEGORY_11330 = 11330,
    CATEGORY_11340 = 11340,
    CATEGORY_11350 = 11350,
    CATEGORY_11360 = 11360,
    CATEGORY_11370 = 11370,
    CATEGORY_12000 = 12000, // Start of Infection Likelyhood based on WBCAnalysis
    CATEGORY_12005 = 12005,
    CATEGORY_12010 = 12010,
    CATEGORY_12015 = 12015,
    CATEGORY_12020 = 12020,
    CATEGORY_12025 = 12025,
    CATEGORY_13000 = 13000,
    CATEGORY_13010 = 13010,
    CATEGORY_13020 = 13020,
    CATEGORY_13030 = 13030,
    CATEGORY_13040 = 13040,
    CATEGORY_13050 = 13050,
    CATEGORY_13060 = 13060,
    CATEGORY_13070 = 13070,
    CATEGORY_13080 = 13080,
    CATEGORY_13090 = 13090,
    CATEGORY_13100 = 13100,
    CATEGORY_13110 = 13110,
    CATEGORY_13120 = 13120,
    CATEGORY_13130 = 13130,
    CATEGORY_13140 = 13140,
    CATEGORY_13150 = 13150,
    CATEGORY_13160 = 13160,
    CATEGORY_13170 = 13170,
    CATEGORY_14000 = 14000,
    CATEGORY_14010 = 14010,
    CATEGORY_14020 = 14020,
    CATEGORY_14030 = 14030,
    CATEGORY_14040 = 14040,
    CATEGORY_14050 = 14050,
    CATEGORY_14060 = 14060,
    CATEGORY_14070 = 14070,
    CATEGORY_14072 = 14072,
    CATEGORY_14074 = 14074,
    CATEGORY_14080 = 14080,
    CATEGORY_14090 = 14090,
    CATEGORY_14100 = 14100,
    CATEGORY_14110 = 14110,
    CATEGORY_14120 = 14120,
    CATEGORY_14130 = 14130,
    CATEGORY_14140 = 14140,
    CATEGORY_14150 = 14150,
    CATEGORY_14160 = 14160,
    CATEGORY_14170 = 14170,
    CATEGORY_14180 = 14180,
    CATEGORY_14190 = 14190,
    CATEGORY_15000 = 15000,
    CATEGORY_15005 = 15005,
    CATEGORY_15006 = 15006,
    CATEGORY_15010 = 15010,
    CATEGORY_15020 = 15020,
    CATEGORY_15030 = 15030,
    CATEGORY_15040 = 15040,
    CATEGORY_15050 = 15050,
    CATEGORY_15060 = 15060,
    CATEGORY_15070 = 15070,
    CATEGORY_15080 = 15080,
    CATEGORY_15090 = 15090,
    CATEGORY_15100 = 15100,
    CATEGORY_15110 = 15110,
    CATEGORY_15120 = 15120,
    CATEGORY_15130 = 15130,
    CATEGORY_15140 = 15140,
    CATEGORY_15150 = 15150,
    CATEGORY_15160 = 15160,
    CATEGORY_15170 = 15170,
    CATEGORY_15180 = 15180,
    CATEGORY_15190 = 15190,
    CATEGORY_15192 = 15192,
    CATEGORY_15194 = 15194,
    CATEGORY_15200 = 15200,
    CATEGORY_15210 = 15210,
    CATEGORY_15220 = 15220,
    CATEGORY_15230 = 15230,
    CATEGORY_15240 = 15240,
    CATEGORY_15250 = 15250,
    CATEGORY_15260 = 15260,
    CATEGORY_15270 = 15270,
    CATEGORY_15280 = 15280,
    CATEGORY_15290 = 15290,
    CATEGORY_15300 = 15300,
    CATEGORY_15310 = 15310,
    CATEGORY_15320 = 15320,
    CATEGORY_15330 = 15330,
    CATEGORY_15340 = 15340,
    CATEGORY_15350 = 15350,
    CATEGORY_15360 = 15360,
    CATEGORY_15370 = 15370,
    CATEGORY_15380 = 15380,
    CATEGORY_15390 = 15390,
    CATEGORY_15400 = 15400,
    CATEGORY_15410 = 15410,
    CATEGORY_15420 = 15420,
    CATEGORY_15430 = 15430,
    CATEGORY_15440 = 15440,
    CATEGORY_15450 = 15450,
    CATEGORY_16000 = 16000,
    CATEGORY_16010 = 16010,
    CATEGORY_16020 = 16020,
    CATEGORY_16030 = 16030,
    CATEGORY_16040 = 16040,
    CATEGORY_16050 = 16050,
    CATEGORY_16060 = 16060,
    CATEGORY_16070 = 16070,
    CATEGORY_16080 = 16080,
    CATEGORY_16090 = 16090,
    CATEGORY_16091 = 16091,
    CATEGORY_16092 = 16092,
    CATEGORY_16094 = 16094,
    CATEGORY_16095 = 16095,
    CATEGORY_16097 = 16097,
    CATEGORY_16100 = 16100,
    CATEGORY_16110 = 16110,
    CATEGORY_17000 = 17000, //Prostate Markers
    CATEGORY_17005 = 17005,
    CATEGORY_17010 = 17010,
    CATEGORY_17015 = 17015,
    CATEGORY_70000 = 70000, // Immune System Abnormality for WBC Analysis section
    CATEGORY_70001 = 70001, // Suppressed Immune Activity for WBC Analysis section
    CATEGORY_70002 = 70002, // Acute Immune Activity for WBC Analysis section
    CATEGORY_70003 = 70003, // Immune System Abnormality for WBC Analysis section
    CATEGORY_70004 = 70004, // Acute Innate (WBC↑ & NLR↑) for WBC Analysis section
    CATEGORY_70005 = 70005, // Acute Adaptive (WBC↑ & NLR↓) for WBC Analysis section
    CATEGORY_70006 = 70006, // Chronic Innate (WBC↓ & NLR↑) for WBC Analysis section
    CATEGORY_70007 = 70007, // Chronic Adaptive (WBC↓ & NLR↓) for WBC Analysis section
    CATEGORY_70008 = 70008, // Innate Immune Response for WBC Analysis section (WBC optimal + NLR ↑)
    CATEGORY_70009 = 70009, // Adaptive Immune Response for WBC Analysis section (WBC optimal + NLR ↓) 
    CATEGORY_70010 = 70010,
    CATEGORY_70011 = 70011,
    CATEGORY_70012 = 70012,
    CATEGORY_70013 = 70013,
    CATEGORY_70014 = 70014,
    CATEGORY_70015 = 70015,
    CATEGORY_70016 = 70016,

    // Glucose Regulation Pattern Categories
    // Formula: categoryId = groupBase + lipidOffset + insulinVariant
    // groupBase: 72000 (Glucose↑+no HbA1c), 72200 (HbA1c↑+no Glucose),
    //            72400 (Glucose↑+HbA1c≤opt), 72600 (HbA1c↑+Glucose≤opt), 72800 (both↑)
    // lipidOffset: 0 (none), +50 (TG/HDL↑), +100 (TG↑+HDL≤opt)
    // insulinVariant: 0 (none), +5 (insulin↑ only), +10 (cp↑ only), +15 (both↑),
    //   +20 (insulin opt only), +25 (cp opt only), +30 (both opt),
    //   +35 (insulin↓ only), +40 (cp↓ only), +45 (both↓)

    // Group 1: Glucose↑, no HbA1c value — no lipid
    CATEGORY_72000 = 72000, CATEGORY_72005 = 72005, CATEGORY_72010 = 72010, CATEGORY_72015 = 72015,
    CATEGORY_72020 = 72020, CATEGORY_72025 = 72025, CATEGORY_72030 = 72030, CATEGORY_72035 = 72035,
    CATEGORY_72040 = 72040, CATEGORY_72045 = 72045,
    // Group 1: TG/HDL↑
    CATEGORY_72050 = 72050, CATEGORY_72055 = 72055, CATEGORY_72060 = 72060, CATEGORY_72065 = 72065,
    CATEGORY_72070 = 72070, CATEGORY_72075 = 72075, CATEGORY_72080 = 72080, CATEGORY_72085 = 72085,
    CATEGORY_72090 = 72090, CATEGORY_72095 = 72095,
    // Group 1: TG↑+HDL≤opt
    CATEGORY_72100 = 72100, CATEGORY_72105 = 72105, CATEGORY_72110 = 72110, CATEGORY_72115 = 72115,
    CATEGORY_72120 = 72120, CATEGORY_72125 = 72125, CATEGORY_72130 = 72130, CATEGORY_72135 = 72135,
    CATEGORY_72140 = 72140, CATEGORY_72145 = 72145,

    // Group 2: HbA1c↑, no Glucose value — no lipid
    CATEGORY_72200 = 72200, CATEGORY_72205 = 72205, CATEGORY_72210 = 72210, CATEGORY_72215 = 72215,
    CATEGORY_72220 = 72220, CATEGORY_72225 = 72225, CATEGORY_72230 = 72230, CATEGORY_72235 = 72235,
    CATEGORY_72240 = 72240, CATEGORY_72245 = 72245,
    // Group 2: TG/HDL↑
    CATEGORY_72250 = 72250, CATEGORY_72255 = 72255, CATEGORY_72260 = 72260, CATEGORY_72265 = 72265,
    CATEGORY_72270 = 72270, CATEGORY_72275 = 72275, CATEGORY_72280 = 72280, CATEGORY_72285 = 72285,
    CATEGORY_72290 = 72290, CATEGORY_72295 = 72295,
    // Group 2: TG↑+HDL≤opt
    CATEGORY_72300 = 72300, CATEGORY_72305 = 72305, CATEGORY_72310 = 72310, CATEGORY_72315 = 72315,
    CATEGORY_72320 = 72320, CATEGORY_72325 = 72325, CATEGORY_72330 = 72330, CATEGORY_72335 = 72335,
    CATEGORY_72340 = 72340, CATEGORY_72345 = 72345,

    // Group 3: Glucose↑, HbA1c measured but ≤ optimal — no lipid
    CATEGORY_72400 = 72400, CATEGORY_72405 = 72405, CATEGORY_72410 = 72410, CATEGORY_72415 = 72415,
    CATEGORY_72420 = 72420, CATEGORY_72425 = 72425, CATEGORY_72430 = 72430, CATEGORY_72435 = 72435,
    CATEGORY_72440 = 72440, CATEGORY_72445 = 72445,
    // Group 3: TG/HDL↑
    CATEGORY_72450 = 72450, CATEGORY_72455 = 72455, CATEGORY_72460 = 72460, CATEGORY_72465 = 72465,
    CATEGORY_72470 = 72470, CATEGORY_72475 = 72475, CATEGORY_72480 = 72480, CATEGORY_72485 = 72485,
    CATEGORY_72490 = 72490, CATEGORY_72495 = 72495,
    // Group 3: TG↑+HDL≤opt
    CATEGORY_72500 = 72500, CATEGORY_72505 = 72505, CATEGORY_72510 = 72510, CATEGORY_72515 = 72515,
    CATEGORY_72520 = 72520, CATEGORY_72525 = 72525, CATEGORY_72530 = 72530, CATEGORY_72535 = 72535,
    CATEGORY_72540 = 72540, CATEGORY_72545 = 72545,

    // Group 4: HbA1c↑, Glucose measured but ≤ optimal — no lipid
    CATEGORY_72600 = 72600, CATEGORY_72605 = 72605, CATEGORY_72610 = 72610, CATEGORY_72615 = 72615,
    CATEGORY_72620 = 72620, CATEGORY_72625 = 72625, CATEGORY_72630 = 72630, CATEGORY_72635 = 72635,
    CATEGORY_72640 = 72640, CATEGORY_72645 = 72645,
    // Group 4: TG/HDL↑
    CATEGORY_72650 = 72650, CATEGORY_72655 = 72655, CATEGORY_72660 = 72660, CATEGORY_72665 = 72665,
    CATEGORY_72670 = 72670, CATEGORY_72675 = 72675, CATEGORY_72680 = 72680, CATEGORY_72685 = 72685,
    CATEGORY_72690 = 72690, CATEGORY_72695 = 72695,
    // Group 4: TG↑+HDL≤opt
    CATEGORY_72700 = 72700, CATEGORY_72705 = 72705, CATEGORY_72710 = 72710, CATEGORY_72715 = 72715,
    CATEGORY_72720 = 72720, CATEGORY_72725 = 72725, CATEGORY_72730 = 72730, CATEGORY_72735 = 72735,
    CATEGORY_72740 = 72740, CATEGORY_72745 = 72745,

    // Group 5: Both Glucose↑ and HbA1c↑ — no lipid
    CATEGORY_72800 = 72800, CATEGORY_72805 = 72805, CATEGORY_72810 = 72810, CATEGORY_72815 = 72815,
    CATEGORY_72820 = 72820, CATEGORY_72825 = 72825, CATEGORY_72830 = 72830, CATEGORY_72835 = 72835,
    CATEGORY_72840 = 72840, CATEGORY_72845 = 72845,
    // Group 5: TG/HDL↑
    CATEGORY_72850 = 72850, CATEGORY_72855 = 72855, CATEGORY_72860 = 72860, CATEGORY_72865 = 72865,
    CATEGORY_72870 = 72870, CATEGORY_72875 = 72875, CATEGORY_72880 = 72880, CATEGORY_72885 = 72885,
    CATEGORY_72890 = 72890, CATEGORY_72895 = 72895,
    // Group 5: TG↑+HDL≤opt
    CATEGORY_72900 = 72900, CATEGORY_72905 = 72905, CATEGORY_72910 = 72910, CATEGORY_72915 = 72915,
    CATEGORY_72920 = 72920, CATEGORY_72925 = 72925, CATEGORY_72930 = 72930, CATEGORY_72935 = 72935,
    CATEGORY_72940 = 72940, CATEGORY_72945 = 72945,

    // Add-ons: Atherogenic Lipid Profile (16.x)
    CATEGORY_73000 = 73000, CATEGORY_73005 = 73005,
    // Add-ons: Hepatic Contribution to Insulin Resistance (17.x)
    CATEGORY_73010 = 73010, CATEGORY_73015 = 73015,
    // Add-ons: CO2 Low — Stress (18.1) / Protein-Driven (18.2)
    CATEGORY_73020 = 73020, CATEGORY_73025 = 73025,
    // Add-ons: Inadequate Pancreatic Response (18.3–18.6)
    CATEGORY_73030 = 73030, CATEGORY_73035 = 73035, CATEGORY_73040 = 73040, CATEGORY_73045 = 73045,
    // Add-ons: Low Glucose Insulin Patterns (19.x)
    CATEGORY_73050 = 73050, CATEGORY_73055 = 73055, CATEGORY_73060 = 73060, CATEGORY_73065 = 73065,
    CATEGORY_73070 = 73070, CATEGORY_73075 = 73075, CATEGORY_73080 = 73080,
    // Add-ons: Low Glucose Context — Protein (20.1), Cortisol (20.2), B6 (20.3),
    //          ALT (20.4), AST (20.5), ALT+AST (20.6)
    CATEGORY_73100 = 73100, CATEGORY_73105 = 73105, CATEGORY_73110 = 73110, CATEGORY_73115 = 73115,
    CATEGORY_73120 = 73120, CATEGORY_73125 = 73125,
    // Add-ons: Optimal Glucose + High Insulin/Cp (21.x)
    CATEGORY_73200 = 73200, CATEGORY_73205 = 73205, CATEGORY_73210 = 73210, CATEGORY_73215 = 73215,
    CATEGORY_73220 = 73220, CATEGORY_73225 = 73225, CATEGORY_73230 = 73230, CATEGORY_73235 = 73235,
    CATEGORY_73240 = 73240,
}